import React, { ReactElement } from 'react'
import { XStack, YStack, Text, XStackProps } from '@red-ui/components'

export type Props = {
  title: string
  body: string
  icon: ReactElement
  boxStyling?: XStackProps
}

export function Alert({ title, body, icon, boxStyling }: Readonly<Props>) {
  return (
    <XStack borderRadius="$3" alignItems="center" paddingHorizontal="$2" paddingVertical="$1" {...boxStyling}>
      {icon}
      <YStack marginLeft="$2" flex={1}>
        <Text fontWeight="600">{title}</Text>
        <Text>{body}</Text>
      </YStack>
    </XStack>
  )
}
